import { GridColDef } from '@mui/x-data-grid';
import { PostRequestStatus } from '@libs/types';
import { formatPhone } from '@libs/utils';

import { PostRequestStatusChip } from '@carcareers/components';

export const CONTACT_REQUEST_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'name',
    headerName: 'Name',
    width: 180,
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 180,
  },
  {
    field: 'businessName',
    headerName: 'Business',
    width: 200,
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 150,
    valueGetter: (_, row) => formatPhone(row.phone) || row.phone || 'N/A',
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 220,
  },
  {
    field: 'positions',
    headerName: 'Positions',
    width: 250,
    valueGetter: (_, row) => (row.positions ?? []).join(', ') || 'N/A',
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 120,
    valueGetter: (_, row) => row.status,
    renderCell: (params) => {
      const status: PostRequestStatus = params.value as PostRequestStatus;
      return <PostRequestStatusChip status={status} />;
    },
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
      }),
  },
];

export const CONTACT_REQUEST_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  name: true,
  title: true,
  businessName: true,
  phone: true,
  email: true,
  positions: true,
  status: true,
  createdAt: true,
};
